import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import { Flex } from 'Components/Base';
import { useComponentSize } from 'Util/Hooks';

const HeaderWrapper = styled(Flex)`
  ${({ display }) => ({
    display: `${display}`,
  })}
`;

const VideoSlideBodyWrapper = styled(Flex)`
  padding: 5px;
`;

const VideoSlideLayout = ({
  header,
  headerProps,
  left,
  leftProps,
  rightLayoutSize,
  right,
  rightProps,
  footer,
  alignment,
}) => {
  const videoSlideLayoutRef = useRef();
  const { _breakpoints } = useTheme();

  const videoSlideSize = useComponentSize(videoSlideLayoutRef);

  const isVerticalLayout = videoSlideSize.width <= _breakpoints[1];

  const isVideoFullWidth = rightLayoutSize === 0;
  const isSlideFullWidth = rightLayoutSize === 1;

  return (
    <Flex flexDirection={'column'} showFooter={footer} ref={videoSlideLayoutRef}>
      <HeaderWrapper display={isVerticalLayout ? 'none' : 'flex'} {...headerProps}>
        {header}
      </HeaderWrapper>
      <VideoSlideBodyWrapper
        height={'100%'}
        alignItems={alignment}
        flexDirection={isVerticalLayout ? 'column' : 'row'}
        showFooter={footer}
      >
        <Flex
          flex={isVerticalLayout ? '1 1 100%' : '1 1 auto'}
          width={isVerticalLayout ? `100%` : `auto`}
          px={isSlideFullWidth || isVerticalLayout ? 0 : 2}
          py={isVerticalLayout ? 2 : 0}
          {...leftProps}
        >
          {left}
        </Flex>
        <Flex
          width={isVerticalLayout ? '100%' : `${rightLayoutSize * 100}%`}
          px={isVideoFullWidth || isVerticalLayout ? 0 : 2}
          py={isVerticalLayout ? 2 : 0}
          {...rightProps}
        >
          {right}
        </Flex>
      </VideoSlideBodyWrapper>
      <Flex>{footer}</Flex>
    </Flex>
  );
};

VideoSlideLayout.propTypes = {
  header: PropTypes.element,
  headerProps: PropTypes.object,
  left: PropTypes.element,
  leftProps: PropTypes.object,
  right: PropTypes.element,
  rightProps: PropTypes.object,
  rightLayoutSize: PropTypes.number,
  footer: PropTypes.element,
  alignment: PropTypes.oneOf(['center', 'flex-end', 'flex-start']),
};

export default VideoSlideLayout;
